// External libraries
import { useEffect } from 'react';

// Internal modules
import { logger } from '../logger';
import { isFunction } from '@/lib/utils/typeUtils';

export const useOnMount = (onMount: () => void): void => {
  if (!isFunction(onMount)) {
    logger.error('on_mount_must_be_a_function');
  }

  useEffect(onMount, []);
};
